import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAppDispatch } from "../../app/hooks";
import { clearWalletIndex } from "./walletSlice";
import { ErrorToast, SuccessToast } from "../../toast/Toasts";
import {
  generateGiftCodeOTP,
  getGiftCodeDetails,
  getWalletBalance,
  redeemGiftCode,
} from "./services/wallet.services";
import { IoMdCloseCircleOutline } from "react-icons/io";
// import {
//   checkGiftCode,
//   redeemGiftCode,
//   getWalletBalance,
// } from "./services/wallet.services";

const AddBalanceViaGiftCode = () => {
  const dispatch = useAppDispatch();

  const formik = useFormik({
    initialValues: {
      giftCode: "",
      amount: 0,
      isValidCode: false,
      isLoading: false,
      isRedeeming: false,
      isShowOTP: false,
      AssignUserID: null,
      OTP: "",
    },
    validationSchema: Yup.object({
      giftCode: Yup.string()
        .required("Gift code is required")
        .max(12, "Gift code should be maxiumn of 12 characters"),
      OTP: Yup.string().when("isShowOTP", {
        is: true,
        then: (schema) =>
          schema
            .required("OTP is required")
            .matches(/^\d{4}$/, "OTP must be exactly 4 digits"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    onSubmit: async (values, { setSubmitting, setFieldValue }) => {
      try {
        if (!values.isValidCode) {
          setFieldValue("isLoading", true);
          const checkResponse: any = await dispatch(
            getGiftCodeDetails(values.giftCode)
          );

          if (checkResponse?.meta.requestStatus === "fulfilled") {
            setFieldValue("amount", checkResponse.payload.Data?.Amount);
            setFieldValue(
              "AssignUserID",
              checkResponse.payload.Data?.AssignUserID
            );
            setFieldValue("isValidCode", true);
            SuccessToast("Valid gift code! You can now redeem it.");
          }
        } else {
          if (+values?.OTP) {
            setFieldValue("isRedeeming", true);
            const redeemResponse: any = await dispatch(
              redeemGiftCode({
                UserID: localStorage.getItem("user_id"),
                AssignUserID: values.AssignUserID,
                GiftCode: values.giftCode,
                OTP: `${values?.OTP}`,
              })
            );

            if (redeemResponse?.meta.requestStatus === "fulfilled") {
              dispatch(getWalletBalance());
              dispatch(clearWalletIndex());
            } else {
              ErrorToast(
                redeemResponse.payload?.Message || "Failed to redeem gift code"
              );
            }
          } else {
            const otpResponse: any = await dispatch(
              generateGiftCodeOTP({
                GiftCode: values.giftCode,
              })
            );

            if (otpResponse?.meta.requestStatus === "fulfilled") {
              setFieldValue("isShowOTP", true);
              // SuccessToast("OTP sent successfully!");
            } else {
              ErrorToast(otpResponse.payload?.Message || "Failed to send OTP");
            }
          }
        }
      } catch (error) {
        console.error("Operation failed:", error);
        ErrorToast("An error occurred. Please try again.");
      } finally {
        setFieldValue("isLoading", false);
        setFieldValue("isRedeeming", false);
        setSubmitting(false);
      }
    },
  });

  return (
    <div className="row mt-3">
      <div className="col-12 wallet-main-card">
        <div className="d-flex justify-content-between">
          <h4>Add Balance via Gift Code</h4>
          <IoMdCloseCircleOutline
            className="fs-3 cursor-pointer"
            onClick={() => dispatch(clearWalletIndex())}
          />
        </div>
        <div className="mt-4">
          <form onSubmit={formik.handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="field">
                  <label
                    className={
                      formik.touched.giftCode && formik.errors.giftCode
                        ? "error-label fs-6"
                        : "fs-6"
                    }
                  >
                    Gift Code <code>*</code>
                  </label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="giftCode"
                      className={`form-control ${
                        formik.touched.giftCode && formik.errors.giftCode
                          ? "error-border"
                          : ""
                      }`}
                      placeholder="Enter gift code"
                      value={formik.values.giftCode}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      disabled={formik.values.isValidCode}
                    />
                    {!formik.values.isValidCode && (
                      <button
                        className="fill-btn manage-btn"
                        style={{ borderRadius: "0 5px 5px 0" }}
                        type="submit"
                        disabled={formik.values.isLoading}
                      >
                        {formik.values.isLoading ? "Checking..." : "View"}
                      </button>
                    )}
                  </div>
                  {formik.touched.giftCode && formik.errors.giftCode && (
                    <div className="error-label">{formik.errors.giftCode}</div>
                  )}
                </div>

                {formik.values.isValidCode && (
                  <div className="mt-3">
                    <div className="alert alert-success mb-0 fs-6 p-2">
                      <span>Gift Code Amount:</span> ₹{" "}
                      <strong>
                        {formik.values.amount?.toLocaleString("en-IN")}
                      </strong>
                    </div>
                  </div>
                )}
                {formik.values.isShowOTP && (
                  <div className="field mt-3">
                    <label
                      className={
                        formik.touched.OTP && formik.errors.OTP
                          ? "error-label fs-6"
                          : "fs-6"
                      }
                    >
                      OTP <code>*</code>
                    </label>
                    <div className="input-group ">
                      <input
                        type="number"
                        name="OTP"
                        className={`form-control ${
                          formik.touched.OTP && formik.errors.OTP
                            ? "error-border"
                            : ""
                        }`}
                        placeholder="Enter OTP"
                        value={formik.values.OTP}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            {formik.values.isValidCode && (
              <div className="d-flex gap-3 mt-3">
                <button
                  type="submit"
                  className="fill-btn manage-btn"
                  disabled={formik.values.isRedeeming}
                >
                  {formik.values.isRedeeming
                    ? "Processing..."
                    : !formik.values.isShowOTP
                    ? "Generate OTP"
                    : "Redeem Code"}
                </button>
                <button
                  type="button"
                  className="btn wallet-cancel-btn"
                  onClick={() => {
                    formik.resetForm();
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddBalanceViaGiftCode;
